'use client'
import { useRouter, useSearchParams } from 'next/navigation'
import { useContext, useEffect } from 'react'
import AuthContext from '../context/AuthContext'

export default function NotFound() {
	const authContext = useContext(AuthContext)
	const router = useRouter()
	const searchParams = useSearchParams().toString()
	useEffect(() => {
		let url = authContext.loggedIn ? '/dashboard/members' : '/login'
		if (searchParams) {
			url = `${url}?${searchParams}`
		}
		router.push(url)
	}, [router, searchParams, authContext.loggedIn])
	return null
}
